/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { Component } from '@angular/core';

@Component({
  selector: 'sita-global-loader',
  standalone: false,
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss'
})
export class GlobalLoaderComponent {
  label = 'Loading...';
}
